import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form';

import CFormRadio from '../../atoms/CFormRadio';

class FormRadioHorizontalInputComponent extends React.Component {
  static get propTypes() {
    return {
      label: PropTypes.string.isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          default: PropTypes.bool,
        }).isRequired
      ).isRequired,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      onChange: PropTypes.func,
    };
  }

  constructor(props) {
    super(props);

    this.state = { options: props.options };

    this.component = this.component.bind(this);
  }

  component(field) {
    return (
      <dl className="c-form">
        <dt className="-lbl">{this.props.label}</dt>
        <dd>
          <div className="l-cols">
            {field.options.map((option, index) => {
              return (
                <CFormRadio
                  key={this.props.label + option.name}
                  name={field.name}
                  id={this.props.id + '-' + (index + 1)}
                  field={field}
                  value={option.value}
                  optionLabel={option.name}
                  input={field.input}
                />
              );
            })}
          </div>
        </dd>
      </dl>
    );
  }

  render() {
    return (
      <Field
        component={this.component}
        name={this.props.name}
        options={this.props.options}
      />
    );
  }
}

export default FormRadioHorizontalInputComponent;
